export const movies = [
  {
    id: 1,
    title: '流浪地球3',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20Earth%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20space%20background%20with%20stars%2C%20warm%20golden%20accents%2C%20clean%20professional%20design&width=600&height=900&seq=movie-poster-01&orientation=portrait',
    rating: 8.5,
    year: 2026,
    category: '科幻',
    slug: 'liu-lang-di-qiu-3',
    description: '太阳急速老化，持续膨胀，地球面临被吞没的灭顶之灾。人类再次踏上流浪之旅，在茫茫宇宙中寻找新的家园。',
    tags: ['科幻', '灾难', '国产大片'],
    featured: true,
  },
  {
    id: 2,
    title: '哪吒之魔童闹海',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%20with%20mythological%20character%2C%20vibrant%20red%20and%20gold%20colors%2C%20epic%20battle%20scene%2C%20traditional%20Chinese%20art%20style%2C%20dramatic%20lighting%2C%20clean%20poster%20design&width=600&height=900&seq=movie-poster-02&orientation=portrait',
    rating: 9.1,
    year: 2025,
    category: '动画',
    slug: 'ne-zha-zhi-mo-tong-nao-hai',
    description: '天劫之后，哪吒和敖丙的灵魂得以保留，但肉身即将消散。太乙真人打算用七色宝莲为二人重塑肉身，却遭遇重重困难。',
    tags: ['动画', '奇幻', '国产'],
    featured: true,
  },
  {
    id: 3,
    title: '封神第二部',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%20with%20ancient%20warriors%20and%20mythological%20beasts%2C%20golden%20and%20crimson%20tone%2C%20cinematic%20lighting%2C%20traditional%20armor%2C%20dramatic%20composition%2C%20clean%20professional%20design&width=600&height=900&seq=movie-poster-03&orientation=portrait',
    rating: 8.8,
    year: 2025,
    category: '奇幻',
    slug: 'feng-shen-di-er-bu',
    description: '殷商大军兵临西岐，姜子牙率领昆仑仙人相助姬发，一场神魔大战即将展开，封神榜的秘密也将逐渐揭晓。',
    tags: ['奇幻', '古装', '神话'],
    featured: true,
  },
  {
    id: 4,
    title: '志愿军：存亡之战',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20war%20drama%20movie%20poster%20with%20soldiers%20in%20battle%2C%20epic%20historical%20scene%2C%20smoke%20and%20explosions%2C%20dramatic%20cinematic%20lighting%2C%20patriotic%20tone%2C%20clean%20professional%20design&width=600&height=900&seq=movie-poster-04&orientation=portrait',
    rating: 8.3,
    year: 2024,
    category: '战争',
    slug: 'zhi-yuan-jun-cun-wang-zhi-zhan',
    description: '1950年，朝鲜战场上的铁原阻击战，中国人民志愿军第63军以寡敌众，浴血奋战，谱写了一曲壮烈的英雄赞歌。',
    tags: ['战争', '历史', '主旋律'],
    featured: false,
  },
  {
    id: 5,
    title: '热辣滚烫',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20boxing%20gloves%20and%20warm%20atmosphere%2C%20inspirational%20tone%2C%20soft%20lighting%2C%20modern%20Chinese%20cinema%20style%2C%20clean%20professional%20design&width=600&height=900&seq=movie-poster-05&orientation=portrait',
    rating: 7.9,
    year: 2024,
    category: '喜剧',
    slug: 're-la-gun-tang',
    description: '善良的乐莹毕业后一直宅在家中，在与外界接触的过程中，她结识了拳击教练昊坤，开始了一段改变人生的旅程。',
    tags: ['喜剧', '励志', '治愈'],
    featured: false,
  },
  {
    id: 6,
    title: '长安三万里',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20movie%20poster%20with%20ancient%20Tang%20Dynasty%20scenery%2C%20poets%20in%20traditional%20robes%2C%20ink%20painting%20style%2C%20elegant%20golden%20tones%2C%20clean%20professional%20design&width=600&height=900&seq=movie-poster-06&orientation=portrait',
    rating: 8.7,
    year: 2023,
    category: '动画',
    slug: 'chang-an-san-wan-li',
    description: '安史之乱后，身处局势之中的高适回忆起自己与李白跨越数十年的情谊，以及那个群星璀璨的盛唐时代。',
    tags: ['动画', '历史', '文学'],
    featured: false,
  },
  {
    id: 7,
    title: '孤注一掷',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20dark%20moody%20atmosphere%2C%20cyber%20theme%2C%20intense%20red%20and%20black%20tones%2C%20suspenseful%20cinematic%20style%2C%20clean%20professional%20design&width=600&height=900&seq=movie-poster-07&orientation=portrait',
    rating: 8.4,
    year: 2023,
    category: '犯罪',
    slug: 'gu-zhu-yi-zhi',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却落入境外诈骗工厂的陷阱，一场惊心动魄的逃亡就此展开。',
    tags: ['犯罪', '悬疑', '现实题材'],
    featured: false,
  },
  {
    id: 8,
    title: '消失的她',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20suspense%20movie%20poster%20with%20couple%20silhouette%20and%20ocean%20background%2C%20dark%20moody%20blue-black%20tone%2C%20thriller%20atmosphere%2C%20clean%20professional%20design&width=600&height=900&seq=movie-poster-08&orientation=portrait',
    rating: 8.1,
    year: 2023,
    category: '悬疑',
    slug: 'xiao-shi-de-ta',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失，当他苦寻无果之时，一个陌生女人突然出现，声称自己才是他的妻子。',
    tags: ['悬疑', '犯罪', '反转'],
    featured: false,
  },
  {
    id: 9,
    title: '熊出没·重启未来',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20children%20animated%20movie%20poster%20with%20bears%20and%20futuristic%20theme%2C%20bright%20colorful%20and%20playful%20design%2C%20family-friendly%20vibe%2C%20clean%20professional%20poster&width=600&height=900&seq=movie-poster-09&orientation=portrait',
    rating: 7.6,
    year: 2026,
    category: '动画',
    slug: 'xiong-chu-mo-chong-qi-wei-lai',
    description: '光头强和熊大熊二意外穿越到未来世界，面对高度发达的科技和未知的挑战，展开了一场爆笑又惊险的冒险。',
    tags: ['动画', '喜剧', '儿童'],
    featured: false,
  },
  {
    id: 10,
    title: '飞驰人生2',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20racing%20car%20and%20desert%20background%2C%20dynamic%20action%20feel%2C%20warm%20cinematic%20tone%2C%20clean%20professional%20design&width=600&height=900&seq=movie-poster-10&orientation=portrait',
    rating: 8.0,
    year: 2024,
    category: '喜剧',
    slug: 'fei-chi-ren-sheng-2',
    description: '昔日冠军车手张驰沦为落魄驾校教练，在机缘巧合下重新踏上巴音布鲁克拉力赛的征途，笑料百出又热血沸腾。',
    tags: ['喜剧', '赛车', '励志'],
    featured: false,
  },
  {
    id: 11,
    title: '第二十条',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%20with%20courtroom%20setting%2C%20serious%20tone%2C%20warm%20lighting%2C%20professional%20atmosphere%2C%20clean%20cinematic%20design&width=600&height=900&seq=movie-poster-11&orientation=portrait',
    rating: 8.2,
    year: 2024,
    category: '剧情',
    slug: 'di-er-shi-tiao',
    description: '一位中年检察官在职业生涯的关键时刻，面临着法律的严肃与人情的温暖的艰难抉择，诠释了法治精神的内涵。',
    tags: ['剧情', '法律', '现实主义'],
    featured: false,
  },
  {
    id: 12,
    title: '九龙城寨之围城',
    poster: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20action%20crime%20movie%20poster%20with%20Kowloon%20Walled%20City%20aesthetic%2C%20neon%20lights%2C%20martial%20arts%20vibe%2C%20dark%20gritty%20tone%2C%20clean%20professional%20design&width=600&height=900&seq=movie-poster-12&orientation=portrait',
    rating: 8.6,
    year: 2024,
    category: '动作',
    slug: 'jiu-long-cheng-zhai-zhi-wei-cheng',
    description: '落魄青年陈洛军误入九龙城寨，在这个三不管地带中卷入帮派纷争，凭借身手与智慧杀出一条血路。',
    tags: ['动作', '犯罪', '港片'],
    featured: true,
  },
];

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-movie-2-line' },
  { name: '动作', slug: 'action', icon: 'ri-boxing-line' },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '科幻', slug: 'scifi', icon: 'ri-rocket-line' },
  { name: '动画', slug: 'animation', icon: 'ri-paint-brush-line' },
  { name: '悬疑', slug: 'suspense', icon: 'ri-search-eye-line' },
  { name: '战争', slug: 'war', icon: 'ri-sword-line' },
  { name: '犯罪', slug: 'crime', icon: 'ri-police-car-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '剧情', slug: 'drama', icon: 'ri-clapperboard-line' },
];

export const articles = [
  {
    id: 1,
    title: '2026年暑期档必看十大国产电影推荐',
    slug: '2026-summer-must-watch',
    summary: '炎炎夏日，电影院里好片不断。我们为你精选了今年暑期档最值得期待的十部国产电影，从科幻大片到温情喜剧，总有一部适合你。',
    content: '<p>2026年的暑期档可谓精彩纷呈，国产电影在题材、制作和口碑上都达到了新的高度。以下是我们为你精心挑选的十大必看影片：</p><h3>1. 《流浪地球3》</h3><p>作为中国科幻电影的标杆之作，《流浪地球3》延续了前两部的宏大叙事，视觉特效再次升级，故事更加深入人心。</p><h3>2. 《哪吒之魔童闹海》</h3><p>这部动画电影以超过50亿的票房创造了中国动画电影的新纪录，精美的画面和动人的故事让无数观众为之落泪。</p><h3>3. 《封神第二部》</h3><p>延续第一部的史诗气质，第二部在战争场面和神话元素上更加宏大，IMAX观影体验堪比好莱坞大片。</p><h3>4. 《熊出没·重启未来》</h3><p>合家欢动画的不二之选，轻松幽默又不失温情，适合全家一起观看。</p><h3>5. 《九龙城寨之围城》</h3><p>港式动作片的回归之作，拳拳到肉的打斗场面和浓浓的港味情怀，让观众大呼过瘾。</p><h3>6. 《热辣滚烫》</h3><p>一部让人笑中带泪的励志喜剧，讲述了一个普通女孩通过拳击找到自我的故事。</p><h3>7. 《飞驰人生2》</h3><p>赛车+喜剧的完美结合，沈腾的表演一如既往地让人捧腹，而拉力赛的紧张刺激又让人肾上腺素飙升。</p><h3>8. 《第二十条》</h3><p>严肃的法律题材在优秀演员的演绎下变得生动感人，引发观众对公平正义的深思。</p><h3>9. 《志愿军：存亡之战》</h3><p>气势磅礴的战争史诗，以铁原阻击战为背景，展现了志愿军战士的英勇无畏。</p><h3>10. 《长安三万里》</h3><p>以盛唐诗歌文化为背景的动画电影，画面精美绝伦，让人仿佛穿越回了那个群星璀璨的时代。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinema%20theater%20interior%20with%20movie%20posters%20on%20walls%2C%20warm%20atmospheric%20lighting%2C%20summer%20vibe%2C%20modern%20Chinese%20cinema%2C%20elegant%20setting%2C%20clean%20professional%20photography&width=1200&height=600&seq=article-cover-01&orientation=landscape',
    publishDate: '2026-07-25',
    category: '影评推荐',
    tags: ['暑期档', '国产电影', '影评', '推荐'],
  },
  {
    id: 2,
    title: '国产科幻电影的崛起：从《流浪地球》到星辰大海',
    slug: 'chinese-scifi-rising',
    summary: '回顾近年来中国科幻电影的发展历程，从《流浪地球》开启新纪元到如今的百花齐放，中国科幻正在书写属于自己的传奇。',
    content: '<p>2019年，《流浪地球》的横空出世，让中国科幻电影站在了一个全新的起点。七年过去了，中国科幻电影已经走出了自己的独特道路。</p><h3>一、《流浪地球》：开天辟地</h3><p>《流浪地球》不仅以46亿票房证明了国产科幻的商业价值，更重要的是它建立了中国科幻电影的工业标准。从特效制作到叙事方式，都为中国科幻奠定了坚实的基础。</p><h3>二、类型多元化</h3><p>如今的国产科幻不再局限于太空题材。从《独行月球》的科幻喜剧，到《宇宙探索编辑部》的伪纪录片风格，再到《明日战记》的机甲动作，国产科幻呈现出百花齐放的态势。</p><h3>三、文化自信的表达</h3><p>与好莱坞科幻片不同，中国科幻电影融入了独特的东方价值观。《流浪地球》中"带着地球去流浪"的设定，体现了中国人对家园的深厚情感，这种文化表达正在成为中国科幻的核心竞争力。</p><h3>四、技术实力的跃升</h3><p>从《流浪地球3》的视觉呈现可以看出，中国特效团队已经达到了世界一流水平。越来越多的国际项目开始邀请中国团队参与特效制作，这是中国电影工业整体进步的最好证明。</p><h3>五、未来可期</h3><p>随着更多优秀创作者的加入和资本的持续投入，中国科幻电影的未来充满想象空间。我们期待看到更多像《三体》这样具有国际影响力的作品诞生。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20cityscape%20with%20sci-fi%20elements%2C%20floating%20structures%2C%20warm%20golden%20and%20amber%20lighting%2C%20cinematic%20atmosphere%2C%20clean%20professional%20photography&width=1200&height=600&seq=article-cover-02&orientation=landscape',
    publishDate: '2026-07-20',
    category: '影评推荐',
    tags: ['科幻', '国产电影', '影评', '流浪地球'],
  },
  {
    id: 3,
    title: '动画电影为何成为票房保证？深度解析国产动画的崛起',
    slug: 'animation-movie-analysis',
    summary: '从《哪吒》到《长安三万里》，国产动画电影屡创票房奇迹。是什么让这些动画电影获得了观众的青睐？',
    content: '<p>近年来，国产动画电影频频创造票房奇迹。《哪吒之魔童降世》50亿、《长安三万里》18亿……这些数字背后，是国产动画电影整体实力的跃升。</p><h3>一、技术突破：视觉盛宴</h3><p>国产动画在CG技术上的进步有目共睹。从角色建模到场景渲染，从动作捕捉到粒子特效，国产动画的技术水平已经接近甚至部分超越了国际一流水平。《哪吒之魔童闹海》中宏大壮丽的东海龙宫场景，其精细程度让人叹为观止。</p><h3>二、故事为王：中国故事的现代表达</h3><p>优秀的技术只是基础，打动人心的故事才是核心。国产动画电影善于从中国传统文化中汲取养分，用现代的叙事方式重新诠释经典。《长安三万里》以高适和李白跨越数十年的友谊为主线，将盛唐诗歌文化融入其中，既有文化底蕴又贴近现代观众的情感。</p><h3>三、全年龄定位：打破"动画即低幼"的偏见</h3><p>过去，国产动画常常被贴上"低幼"的标签。如今的优秀国产动画电影，已经成功实现了全年龄覆盖。儿童能看到精彩的画面和有趣的故事，成年人则能感受到更深层的情感共鸣和人生思考。</p><h3>四、产业链完善</h3><p>从IP开发到衍生品授权，国产动画电影的产业链正在逐步完善。这不仅为动画制作提供了更充足的资金保障，也为整个行业的可持续发展奠定了基础。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artists%20working%20on%20digital%20tablets%2C%20colorful%20character%20designs%20on%20screens%2C%20warm%20creative%20atmosphere%2C%20clean%20professional%20photography&width=1200&height=600&seq=article-cover-03&orientation=landscape',
    publishDate: '2026-07-15',
    category: '行业动态',
    tags: ['动画', '国产电影', '票房', '产业分析'],
  },
  {
    id: 4,
    title: '港片不死：从《九龙城寨之围城》看香港电影的复兴',
    slug: 'hk-movie-revival',
    summary: '《九龙城寨之围城》的口碑与票房双丰收，让人们再次看到了香港电影的生命力。港片的复兴之路，正在悄然展开。',
    content: '<p>曾经辉煌的香港电影，在经历了低谷期后，正在以全新的姿态回归。《九龙城寨之围城》的成功，让人们看到了港片复兴的希望。</p><h3>一、九龙城寨：一个时代的符号</h3><p>九龙城寨，这个已经消失的传奇地带，承载了几代人的记忆。电影将这个独特空间搬上银幕，不仅还原了其错综复杂的建筑风貌，更捕捉了那种独特的江湖气息。</p><h3>二、动作美学的新高度</h3><p>香港动作片有着悠久的历史和深厚的底蕴。《九龙城寨之围城》中的动作设计，既传承了港式武打的精髓，又融入了现代拍摄手法，创造出令人惊艳的视觉效果。</p><h3>三、本土叙事的回归</h3><p>近年的优秀港片，从《毒舌律师》到《九龙城寨之围城》，都选择了扎根本土的叙事方式。与其模仿好莱坞，不如讲好自己的故事——这正在成为香港电影人的共识。</p><h3>四、新老结合的人才梯队</h3><p>古天乐、洪金宝等老牌影星与新锐演员的搭配，经验丰富的导演与年轻创作者的合作，为香港电影注入了新的活力。这种新老结合的良性循环，是港片持续发展的重要保障。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cityscape%20at%20night%20with%20neon%20signs%20and%20busy%20streets%2C%20cinematic%20moody%20atmosphere%2C%20warm%20street%20lights%2C%20urban%20vibe%2C%20clean%20professional%20photography&width=1200&height=600&seq=article-cover-04&orientation=landscape',
    publishDate: '2026-07-10',
    category: '行业动态',
    tags: ['港片', '动作片', '九龙城寨', '电影复兴'],
  },
  {
    id: 5,
    title: '看电影学历史：五部高质量历史题材电影推荐',
    slug: 'historical-movies-guide',
    summary: '历史题材电影不仅是娱乐，更是了解历史的一扇窗口。本文为你推荐五部制作精良、尊重史实的国产历史电影。',
    content: '<p>好的历史电影，能够让我们在享受视听盛宴的同时，深入了解那段历史。以下五部国产历史题材电影，值得每一位观众细细品味。</p><h3>1. 《长安三万里》</h3><p>以安史之乱前后的唐朝为背景，通过高适的视角，展现了李白、杜甫等诗人的风采以及盛唐由盛转衰的历史变迁。影片对唐代服饰、建筑、礼仪的还原度极高。</p><h3>2. 《志愿军：存亡之战》</h3><p>聚焦抗美援朝战争中的铁原阻击战，以真实历史事件为蓝本，展现了志愿军将士的英勇与牺牲精神。战争场面震撼人心，人物刻画细腻入微。</p><h3>3. 《封神第一部》</h3><p>改编自中国古典神话小说《封神演义》，虽然是神话故事，但影片在商周时期的历史背景上做了大量考据，服饰、兵器、礼仪都有历史依据。</p><h3>4. 《满江红》</h3><p>以南宋为背景的悬疑喜剧，虽然故事虚构，但影片对南宋时期的政治生态和社会风貌有着精准的把握，让观众在笑声中感受历史的厚重。</p><h3>5. 《长津湖》</h3><p>以抗美援朝战争中的长津湖战役为背景，真实再现了那场惊心动魄的战争。影片不仅展现了战争的残酷，更传递了和平的珍贵。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20historical%20architecture%2C%20warm%20sunset%20lighting%2C%20traditional%20Chinese%20elements%2C%20elegant%20serene%20atmosphere%2C%20clean%20professional%20photography&width=1200&height=600&seq=article-cover-05&orientation=landscape',
    publishDate: '2026-07-05',
    category: '影评推荐',
    tags: ['历史', '国产电影', '影评', '推荐'],
  },
  {
    id: 6,
    title: '2026下半年最受期待的五部国产大片前瞻',
    slug: '2026-second-half-preview',
    summary: '2026年已过半，下半年还有哪些值得期待的国产大片即将上映？本文为你提前揭秘。',
    content: '<p>2026年上半年国产电影市场表现亮眼，多部影片取得了口碑与票房的双丰收。下半年，还有哪些重磅作品值得期待？让我们一探究竟。</p><h3>1. 《流浪地球3》</h3><p>作为暑期档的重头戏，《流浪地球3》已经创造了多项票房纪录。如果你还没看，这个夏天一定不要错过。</p><h3>2. 《大决战》三部曲重制版</h3><p>经典战争史诗《大决战》系列经过4K修复和重新调色，将在下半年以IMAX格式重新上映，让新一代观众在大银幕上感受这部经典的魅力。</p><h3>3. 《三体》电影版</h3><p>万众期待的《三体》电影版终于定档下半年，由顶级制作团队打造，力求还原刘慈欣笔下的宏大宇宙观。</p><h3>4. 《深海2》</h3><p>《深海》以惊人的视觉效果震撼了观众，续集将继续探索深海世界的神秘与美丽，制作团队表示视觉效果将再次升级。</p><h3>5. 《我和我的家乡3》</h3><p>延续前两部的成功模式，由多位知名导演联合执导，用温暖幽默的方式讲述中国各地的家乡故事。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20entrance%20with%20upcoming%20movie%20posters%20display%2C%20modern%20design%2C%20warm%20inviting%20atmosphere%2C%20bright%20lighting%2C%20clean%20professional%20photography&width=1200&height=600&seq=article-cover-06&orientation=landscape',
    publishDate: '2026-07-01',
    category: '行业动态',
    tags: ['前瞻', '国产大片', '档期', '期待'],
  },
];